'use client';

import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import QuotedTextBlock from '@/features/contentful/components/QuotedTextBlock';

const BlockQuote = ({ component }: { component: any }) => {
    const inspectorProps = useContentfulInspectorMode({ entryId: component.componentId });

    return (
        <QuotedTextBlock
            summary={component?.fields?.blockQuote}
            shortText={component?.fields?.citation}
            key={component.componentId}
            {...inspectorProps({
                fieldId: 'blockQuote',
            })}
        />
    );
};

export default BlockQuote;
